function generateRandomPassword() {
  const specs = [
    "abcdefghijklmnopqrstuvwxyz",
    "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
    "0123456789",
    "!@#$%^&*()-_=+[]{}|;:,.<>?",
  ];

  return Array(3)
    .fill("")
    .map(() => {
      return specs.reduce((prev, val, index) => {
        return prev + specs[index][Math.floor(Math.random() * specs[index].length)];
      }, "");
    })
    .join("");
}

export { generateRandomPassword };
